<template>
  <answer-template
    :answer-type="'video'"
    :input-data="inputData"
    :index="index"
    :wrapper-class="'video-answer'"
    @deleted="$emit('deleted')"
  >
    <template v-slot:label>Send video</template>
    <template v-slot:content>
      <div class="video-box" @mouseover="onHover=true" @mouseleave="onHover=false">
        <div class="center-btn"
             :class="{'has-video': !noUrl}"
             v-show="onHover || noUrl" @click="setMediaUrl">
              <span class="icon">
                <font-awesome-icon icon="pen"></font-awesome-icon>
              </span>
        </div>
        <div class="video">
          <video class="fullwidth" ref="video_ref" controls
                 v-on:loadedmetadata="loadedMetaData"
                 v-html="videoSrc">
          </video>
        </div>
      </div>
    </template>
  </answer-template>
</template>
<script>
import AnswerTemplate from './AnswerTemplate.vue';

export default {
  name: 'videoAnswer',
  components: {
    AnswerTemplate,
  },
  props: {
    inputData: {
      type: Object,
      default() {
        return {
          type: 'send_video',
          url: '',
        };
      },
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      onHover: false,
      tempInput: '',
      validCheck: false,
    };
  },
  methods: {
    loadedMetaData() {
      // console.log(e);
      this.$nextTick(() => {
        this.inputData.playable = true;
        this.validCheck = !this.validCheck;
      });
    },
    toggleDirty() {
      this.$emit('dirty');
    },
    removeBlock() {
      this.$buefy.dialog.confirm({
        title: 'Removing video block',
        message: 'Are you sure to remove this video block?',
        cancelText: 'Cancel',
        confirmText: 'Remove',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$emit('deleted');
        },
      });
    },
    setMediaUrl() {
      if (this.inputData.url) {
        this.tempInput = this.inputData.url;
      } else {
        this.tempInput = '';
      }
      this.$buefy.dialog.prompt({
        title: 'Video message',
        message: 'Please enter video url. (Must be https:// and mp4 video format)',
        inputAttrs: {
          placeholder: 'e.g. https://sample-videos.com/test.mp4',
          pattern: '^(https:\\/\\/)[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$',
          value: this.tempInput,
          title: 'URL must be https. and mp4 video format',
        },
        onConfirm: (url) => {
          this.inputData.url = url;
          this.inputData.playable = false;
          this.$nextTick(() => {
            const videoObj = this.$refs.video_ref;
            if (videoObj) {
              videoObj.load();
            }
          });
          this.toggleDirty();
        },
      });
    },
  },
  computed: {
    noUrl() {
      return !this.inputData.url;
    },
    videoSrc() {
      if (this.inputData.url) {
        return `<source type="video/mp4" src="${this.inputData.url}">`;
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
  .video-answer {
    .video-box {
      background-color: #eee;
      border: 1px solid #eee;
      min-height: 200px;
      position: relative;
      .center-btn {
        z-index: 10;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -15px;
        margin-left: -20px;
        cursor: pointer;
        color: #797979;
        background-color: rgba(238, 238, 238, 0.8);
        border-radius: 50px;
        padding: 5px 10px 3px 10px;
        line-height: 20px;
        &:hover {
          color: #333;
        }
        &.has-video {
          top: 40%;
          left: 60%;
          margin-top: -10px;
          margin-left: -5px;
        }
      }
      .video {
        width: 100%;
      }
      video.fullwidth {
        min-width: 320px;
        width: 100% !important;
      }
    }
  }
</style>
